<template><div class="d-flex justify-center">

	<div v-if="!story" style="width: 100%; max-width: 600px" class="d-flex flex-wrap">
		<div v-for="s in Object.keys(texts)" class="book pa-5" @click="$router.push('/reading/' + s)">
			<img src="@/assets/book.svg">
			<div class="text-center"> {{ $t(s.replace(/-/g, ' ')) }} </div>
		</div>
	</div>

	<div v-else style="max-width: 600px" class="pa-5">
		<div class="text-center text-h4 text-sm-h3 pb-5"> {{ story.replace(/-/g, ' ') }} </div>
		<nao v-if="cur_text" nodecor :n="cur_text"/>
		<div class="pa-5 d-flex justify-center">
			<v-btn @click="$router.push('/reading/')">Back to the library</v-btn>
		</div>
	</div>


</div></template>


<script>

import Vue from 'vue'
import nao from '@/components/Naoword'
import texts from './reading_texts'

//let texts;


export default {
	components: {nao},
	data: function() {
		return {
			
		}
	},
	methods: {

	},
	computed: {
		cur_text() {
			return texts[this.story];
		},
		story() {
			return this.$route.params.story;
		}
	},
	created() {
		//texts = () => import('./reading_texts');
		this.texts = texts;
	}
}
</script>

<style scoped>

.book {
	width: 150px;
	cursor: pointer;
}

</style>